<template>
  <div v-if="this.a.A_NOM_DE !== null && this.a.A_NOM_DE !== undefined">
    <div>
      <wizard-steps
        :current-step="2"
        :show-third-step="a.A_NOM_DE === 1"
        :show-single-title="page === 6"
      ></wizard-steps>
    </div>
    <div class="alert-form-container">
      <div class="pb-3">
        <b-table
          striped
          hover
          v-if="a.PERSONAS_EN_RIESGO.length"
          class="d-none d-md-table"
          :items="a.PERSONAS_EN_RIESGO"
          :fields="['NOMBRE', 'APELLIDO', 'DOCUMENTO', 'OPCIONES']"
        >
          <template #cell(OPCIONES)="data">
            <b-badge
              style="font-size: 0.8rem; cursor: pointer"
              variant="primary"
              class="mx-2"
              @click="editPersona(data.item)"
            >
              <fai :icon="['fa', 'edit']" />
              Editar
            </b-badge>
          </template>
        </b-table>
      </div>

      <div class="accordion d-block d-md-none pb-3" v-if="a.PERSONAS_EN_RIESGO.length">
        <h5>Personas Afectadas:</h5>
        <b-card no-body class="m-0" v-for="(person, index) of a.PERSONAS_EN_RIESGO" :key="index">
          <b-card-header
            header-tag="header"
            class="p-1"
            role="tab"
            v-b-toggle="'accordion-' + index"
          >
            <b-button class="float-right" size="md" variant="default">
              <fai icon="angle-down" aria-hidden="true"></fai>
            </b-button>
            <div class="m-auto p-2">
              <span>{{ person.NOMBRE }}</span>
              <span>{{ person.APELLIDO }}</span>
            </div>
          </b-card-header>
          <b-collapse :id="'accordion-' + index" accordion="my-accordion" role="tabpanel">
            <b-list-group>
              <b-list-group-item>
                <b-button block variant="secondary" @click="editPersona(person)">
                  <fai :icon="['fa', 'edit']" />
                  Editar
                </b-button>
              </b-list-group-item>
              <b-list-group-item>
                <strong>NOMBRE:</strong>
                <span class="float-right">{{ person.NOMBRE }}</span>
              </b-list-group-item>
              <b-list-group-item>
                <strong>APELLIDO:</strong>
                <span class="float-right">{{ person.APELLIDO }}</span>
              </b-list-group-item>
              <b-list-group-item>
                <strong>DOCUMENTO:</strong>
                <span class="float-right">{{ person.DOCUMENTO }}</span>
              </b-list-group-item>
              <b-list-group-item>
                <strong>TELEFONO:</strong>
                <span class="float-right">{{ person.TELEFONO }}</span>
              </b-list-group-item>
            </b-list-group>
          </b-collapse>
        </b-card>
      </div>

      <b-alert :show="a.id" dismissible>
        <small>
          Recuerde que debe actualizar la alerta para que los Afectados creados y/o actualizados
          sean almacenados en la base de datos.
        </small>
      </b-alert>
      <b-row v-show="showForm" align-v="end">
        <b-col cols="12" md="3">
          <b-form-group
            :invalid-feedback="fb.NOMBRE"
            :class="{ required: this.a.A_NOM_DE === 0 }"
            :state="vNombre()"
            :label="labels('NOMBRE')"
            label-for="NOMBRE"
          >
            <b-form-input id="NOMBRE" :state="vNombre()" v-model="as.NOMBRE"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="3">
          <b-form-group
            :invalid-feedback="fb.APELLIDO"
            :class="{ required: this.a.A_NOM_DE === 0 }"
            :state="vApellido()"
            :label="labels('APELLIDO')"
            label-for="APELLIDO"
          >
            <b-form-input id="APELLIDO" :state="vApellido()" v-model="as.APELLIDO"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="3">
          <b-form-group
            :invalid-feedback="fb.DOCUMENTO"
            :class="{ required: this.a.A_NOM_DE === 0 }"
            :state="vDocumento()"
            :label="labels('DOCUMENTO')"
            label-for="DOCUMENTO"
          >
            <div class="row">
              <div class="col-4">
                <b-dropdown class="satmed-btn-dropdown">
                  <template #button-content>
                    {{ getTextById(as.TIPO_DOCUMENTO_ID, 'tiposDocumentos', 'sigla') }}
                  </template>
                  <b-dropdown-item
                    v-for="(tipo, index) in tiposDocumentos"
                    @click="as.TIPO_DOCUMENTO_ID = tipo.value"
                    :key="index"
                    class="satmed-input-style"
                  >
                    <div class="d-flex">
                      <div style="min-width: 55px">
                        <b>
                          {{ tipo.sigla }}
                        </b>
                      </div>
                      <div>- {{ tipo.text }}</div>
                    </div>
                  </b-dropdown-item>
                </b-dropdown>
              </div>
              <div class="col-8">
                <b-form-input
                  placeholder="No."
                  id="DOCUMENTO"
                  v-model="as.DOCUMENTO"
                  :disabled="!as.TIPO_DOCUMENTO_ID"
                  :state="vDocumento()"
                  class="satmed-btn-dropdown"
                ></b-form-input>
              </div>
            </div>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="3">
          <b-form-group
            :invalid-feedback="fb.PAIS_NACIMIENTO_ID"
            :class="{ required: a.A_NOM_DE === 0 }"
            :state="validateBirthCountry()"
            :label="labels('PAIS_NACIMIENTO_ID')"
            label-for="PAIS_NACIMIENTO_ID"
          >
            <b-select
              id="PAIS_NACIMIENTO_ID"
              :options="countries"
              :state="validateBirthCountry()"
              v-model="as.PAIS_NACIMIENTO_ID"
            ></b-select>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="3">
          <b-form-group
            :invalid-feedback="fb.GENERO"
            :class="{ required: this.a.A_NOM_DE === 0 }"
            :state="vGeneroId()"
            :label="labels('GENERO_ID')"
            label-for="GENERO_ID"
          >
            <b-select
              id="GENERO_ID"
              :options="generos"
              :state="vGeneroId()"
              v-model="as.GENERO_ID"
            ></b-select>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="3">
          <b-form-group
            :invalid-feedback="fb.ORIENTACION_ID"
            :class="{ required: this.a.A_NOM_DE === 0 }"
            :state="vOrientacionId()"
            :label="labels('ORIENTACION_ID')"
            label-for="ORIENTACION_ID"
          >
            <b-select
              id="ORIENTACION_ID"
              :state="vOrientacionId()"
              :options="orientacionesSexuales"
              v-model="as.ORIENTACION_ID"
            ></b-select>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="3">
          <b-form-group
            :invalid-feedback="fb.IDENTIDAD_GENERO_ID"
            :class="{ required: this.a.A_NOM_DE === 0 }"
            :state="validateGenderIdentity()"
            :label="labels('IDENTIDAD_GENERO_ID')"
            label-for="IDENTIDAD_GENERO_ID"
          >
            <template slot="label">
              {{ labels('IDENTIDAD_GENERO_ID') }}
              <fai v-b-popover.hover="popoverConfig" :icon="['fa', 'info-circle']" />
            </template>
            <b-select
              id="IDENTIDAD_GENERO_ID"
              :options="genderIdentities"
              :state="validateGenderIdentity()"
              v-model="as.IDENTIDAD_GENERO_ID"
            ></b-select>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="3">
          <b-form-group
            :invalid-feedback="fb.RANGO_EDAD_ID"
            :state="vRangoEdadId()"
            :label="labels('RANGO_EDAD_ID')"
            label-for="RANGO_EDAD_ID"
            class="flex-shrink-1 required"
          >
            <b-select id="RANGO_EDAD_ID" :state="vRangoEdadId()" v-model="as.RANGO_EDAD_ID"
                      :options='ageRanges'></b-select>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="3">
          <b-form-group
            :invalid-feedback="fb.FECHA_NACIMIENTO"
            :class="{ required: this.a.A_NOM_DE === 0 }"
            :label="labels('FECHA_NACIMIENTO')"
            :state="validateBirthDate()"
            label-for="FECHA_NACIMIENTO"
          >
            <satmed-datepicker
              id="FECHA_NACIMIENTO"
              :value="as.FECHA_NACIMIENTO"
              v-on:input="updateBirthDate($event)"
            ></satmed-datepicker>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="3">
          <b-form-group
            :invalid-feedback="fb.NIVEL_ESCOLAR_ID"
            :class="{ required: a.A_NOM_DE === 0 }"
            :state="vNivelEscolarId()"
            :label="labels('NIVEL_ESCOLAR_ID')"
            label-for="NIVEL_ESCOLAR_ID"
          >
            <b-select
              id="NIVEL_ESCOLAR_ID"
              v-model="as.NIVEL_ESCOLAR_ID"
              :options="nivelesEscolares"
              :state="vNivelEscolarId()"
            ></b-select>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="3" v-show="filteredSchoolGrades.length > 1">
          <b-form-group
            :invalid-feedback="fb.GRADO_ESCOLAR_ID"
            :class="{ required: a.A_NOM_DE === 0 }"
            :state="vGradoEscolarId()"
            :label="labels('GRADO_ESCOLAR_ID')"
            label-for="GRADO_ESCOLAR_ID"
          >
            <b-select
              id="GRADO_ESCOLAR_ID"
              v-model="as.GRADO_ESCOLAR_ID"
              :options="filteredSchoolGrades"
              :state="vGradoEscolarId()"
            ></b-select>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="3">
          <b-form-group
            :invalid-feedback="fb.NUMERO_HIJOS_ID"
            :class="{ required: a.A_NOM_DE === 0 }"
            :state="vNumeroHijosId()"
            :label="labels('NUMERO_HIJOS_ID')"
            label-for="nombre"
          >
            <b-select
              :options="numeroHijos"
              :state="vNumeroHijosId()"
              v-model="as.NUMERO_HIJOS_ID"
            ></b-select>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="3">
          <b-form-group
            :invalid-feedback="fb.CARACTERISTICAS_DIFERENCIALES"
            :class="{ required: a.A_NOM_DE === 0 }"
            :state="validateDifferentialCharacteristics()"
            :label="labels('CARACTERISTICAS_DIFERENCIALES')"
            label-for="CARACTERISTICAS"
          >
            <b-dropdown
              id="CARACTERISTICAS"
              boundary="viewport"
              :text="characteristicsText"
              class="satmed-btn-dropdown"
            >
              <b-dropdown-form style="min-width: 40vw">
                <b-row>
                  <b-col cols="12" md="6" class="p-0 text-nowrap">
                    <b-form-checkbox
                      class="satmed-input-style"
                      v-model="as.CARACT_RURAL"
                      :value="1"
                      :unchecked-value="0"
                      @change="updateCharacteristicText('Rural', as.CARACT_RURAL)"
                    >
                      Rural
                    </b-form-checkbox>
                  </b-col>
                  <b-col cols="12" md="6" class="p-0">
                    <b-form-checkbox
                      v-model="as.CARACT_URBANO"
                      :value="1"
                      :unchecked-value="0"
                      @change="updateCharacteristicText('Urbano/a', as.CARACT_URBANO)"
                    >
                      Urbano/a
                    </b-form-checkbox>
                  </b-col>
                  <b-col cols="12" md="6" class="p-0">
                    <b-form-checkbox
                      v-model="as.CARACT_CAMPESINO"
                      :value="1"
                      :unchecked-value="0"
                      @change="updateCharacteristicText('Campesino/a', as.CARACT_CAMPESINO)"
                    >
                      Campesino/a
                    </b-form-checkbox>
                  </b-col>
                  <b-col cols="12" md="6" class="p-0">
                    <b-form-checkbox
                      v-model="as.CARACT_INDIGENA"
                      :value="1"
                      :unchecked-value="0"
                      @change="updateCharacteristicText('Indígena', as.CARACT_INDIGENA)"
                    >
                      Indígena
                    </b-form-checkbox>
                  </b-col>
                  <b-col cols="12" md="6" class="p-0">
                    <b-form-checkbox
                      v-model="as.CARACT_MESTIZO"
                      :value="1"
                      :unchecked-value="0"
                      @change="updateCharacteristicText('Mestizo', as.CARACT_MESTIZO)"
                    >
                      Mestizo
                    </b-form-checkbox>
                  </b-col>
                  <b-col cols="12" md="6" class="p-0">
                    <b-form-checkbox
                      v-model="as.CARACT_AFRO_COLOMBIANO"
                      :value="1"
                      :unchecked-value="0"
                      @change="
                        updateCharacteristicText('Afro-colombiano/a', as.CARACT_AFRO_COLOMBIANO)
                      "
                    >
                      Afro-colombiano/a
                    </b-form-checkbox>
                  </b-col>
                  <b-col cols="12" md="6" class="p-0">
                    <b-form-checkbox
                      v-model="as.CARACT_ISLENIO"
                      :value="1"
                      :unchecked-value="0"
                      @change="updateCharacteristicText('Isleño/a', as.CARACT_ISLENIO)"
                    >
                      Isleño/a
                    </b-form-checkbox>
                  </b-col>
                  <b-col cols="12" md="6" class="p-0">
                    <b-form-checkbox
                      v-model="as.CARACT_RAIZAL"
                      :value="1"
                      :unchecked-value="0"
                      @change="updateCharacteristicText('Raizal', as.CARACT_RAIZAL)"
                    >
                      Raizal
                    </b-form-checkbox>
                  </b-col>
                  <b-col cols="12" md="6" class="p-0">
                    <b-form-checkbox
                      v-model="as.CARACT_GITANO"
                      :value="1"
                      :unchecked-value="0"
                      @change="updateCharacteristicText('Gitano/a', as.CARACT_GITANO)"
                    >
                      Gitano/a - ROM
                    </b-form-checkbox>
                  </b-col>
                  <b-col cols="12" md="6" class="p-0">
                    <b-form-checkbox
                      v-model="as.CARACT_CON_DISCAPACIDAD"
                      :value="1"
                      :unchecked-value="0"
                      @change="updateCharacteristicText('Discapacidad', as.CARACT_CON_DISCAPACIDAD)"
                    >
                      Persona con discapacidad
                    </b-form-checkbox>
                  </b-col>
                  <b-col cols="12" md="6" class="p-0">
                    <b-form-checkbox
                      v-model="as.CARACT_LGBTI"
                      :value="1"
                      :unchecked-value="0"
                      @change="updateCharacteristicText('LGBTI', as.CARACT_LGBTI)"
                    >
                      Población LGBTI
                    </b-form-checkbox>
                  </b-col>
                  <b-col cols="12" md="6" class="p-0">
                    <b-form-checkbox
                      v-model="as.CARACT_MIGRANTE"
                      :value="1"
                      :unchecked-value="0"
                      @change="updateCharacteristicText('Migrante', as.CARACT_MIGRANTE)"
                    >
                      Población Migrante
                    </b-form-checkbox>
                  </b-col>
                  <b-col cols="12" md="6" class="p-0">
                    <b-form-checkbox
                      v-model="as.CARACT_CONFLICO_ARMADO"
                      :value="1"
                      :unchecked-value="0"
                      @change="updateCharacteristicText('Víctima', as.CARACT_CONFLICO_ARMADO)"
                    >
                      Víctima del conflicto armado
                    </b-form-checkbox>
                  </b-col>
                  <b-col cols="12" md="6" class="p-0">
                    <b-form-checkbox
                      v-model="as.CARACT_NO_IDENTIFICA"
                      :value="1"
                      :unchecked-value="0"
                      @change="updateCharacteristicText('No identifica', as.CARACT_NO_IDENTIFICA)"
                    >
                      No identifica
                    </b-form-checkbox>
                  </b-col>
                </b-row>
              </b-dropdown-form>
            </b-dropdown>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="3">
          <b-form-group
            :invalid-feedback="fb.TELEFONO"
            :class="{ required: a.A_NOM_DE === 0 }"
            :state="vTelefono()"
            :label="labels('TELEFONO')"
            label-for="TELEFONO"
          >
            <b-form-input id="TELEFONO" :state="vTelefono()" v-model="as.TELEFONO"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="3">
          <b-form-group :label="labels('ESPERA_BEBE')" label-for="nombre">
            <b-form-radio-group
              v-model="as.ESPERA_BEBE"
              :options="[
                { text: 'Sí', value: 1 },
                { text: 'No', value: 0 },
                { text: 'No lo sé', value: 2 },
              ]"
            ></b-form-radio-group>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6" class="pb-4">
          <b-radio v-model="as.POLITICA" :value="true">
            Sí, acepto la
            <a
              :href="`${baseUrl}Politica_Proteccion_Datos.pdf`"
              target="_blank"
              rel="noopener noreferrer"
            >
              Política de Protección de Datos
            </a>
            y el
            <a
              :href="`${baseUrl}Decreto_1096_de_2018.pdf`"
              target="_blank"
              rel="noopener noreferrer"
            >
              Decreto 1096 de 2018
            </a>
          </b-radio>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import WizardSteps from '@/components/UI/WizardSteps.vue';
import { expresiones } from '@/assets/expresionesRegulares';

export default {
  name: 'PaginaNombreDe',
  props: {
    page: Number,
    editar: {
      default: null,
    },
  },
  components: {
    WizardSteps,
  },
  data() {
    return {
      /** @type {any} */
      as: {},
      showForm: true,
      comunaSelected: null,
      barrioSelected: null,
      fb: {
        NOMBRE: '',
        APELLIDO: '',
        DOCUMENTO: '',
        GENERO: '',
        PAIS_NACIMIENTO_ID: null,
        ORIENTACION_ID: '',
        IDENTIDAD_GENERO_ID: '',
        RANGO_EDAD_ID: '',
        FECHA_NACIMIENTO: null,
        NIVEL_ESCOLAR_ID: '',
        NUMERO_HIJOS_ID: '',
        GRADO_ESCOLAR_ID: '',
        TELEFONO: '',
        CARACTERISTICAS_DIFERENCIALES: null,
      },
      baseUrl: process.env.BASE_URL,
      /** @type {string[]} */
      characteristicsSelected: [],
      characteristicsText: 'Seleccionar...',
    };
  },
  computed: {
    ...mapState({
      /** @returns {{PERSONAS_EN_RIESGO: any[]} & {[key:string]: any}} */
      a: (state) => state.alerta.item,
      ad: (state) => JSON.parse(JSON.stringify(state.alerta.afectadoDefault)),
      countries: (state) => state.alerta.countries,
      ageRanges: (state) => state.alerta.ageRanges,
    }),
    ...mapState('alerta', [
      'tiposDocumentos',
      'generos',
      'orientacionesSexuales',
      'genderIdentities',
      'nivelesEscolares',
      'gradosEscolares',
      'numeroHijos',
      'ageRanges',
    ]),
    ...mapGetters('alerta', ['getTextById']),
    filteredSchoolGrades() {
      if (this.as.NIVEL_ESCOLAR_ID === null) {
        return [];
      }
      const scholarGrades = [];
      for (let i = 0; i < this.gradosEscolares.length; i += 1) {
        const scholarGrade = this.gradosEscolares[i];

        if (
          scholarGrade.scholarLevelId === null
          || scholarGrade.scholarLevelId === this.as.NIVEL_ESCOLAR_ID
        ) {
          scholarGrades.push(scholarGrade);
        }
      }
      return scholarGrades;
    },
    popoverConfig() {
      return {
        html: true,
        content: () =>
          // eslint-disable-next-line implicit-arrow-linebreak
          '<b>IDENTIDAD DE GÉNERO:</b><br>La forma como cada persona vive y experimenta el género de manera que puede corresponder o no con el sexo que le fue asignado/diagnosticado al nacer.<br><b>Mujer trans:</b> Mujer cuya identidad de género no corresponde con el sexo diagnosticado al nacer. Persona que debido a su anatomía sexual fue diagnosticada como hombre al nacer, pero se identifica y vive desde lo femenino, como una mujer<br><b>Hombre trans:</b> Hombre cuya identidad de género no corresponde con el sexo diagnosticado al nacer. Persona que debido a su anatomía sexual fue diagnosticada como mujer al nacer, pero se identifica y vive desde lo masculino, como un hombre.<br><b>No binario:</b> Persona que no se identifica en el binario de género mujer/hombre, sino fuera de éste. Algunas personas no binarias se reconocen como Trans* y otras no.<br><b>Género fluido:</b> Persona cuya identidad de género transita continuamente entre el binario mujer-hombre, sin ubicarse en alguna de estas dos categorías, pero tampoco fuera de ellas.<br><b>Mujer cis:</b> Mujer cuya identidad de género si corresponde con el sexo diagnosticado al nacer<br><b>Hombre cis:</b> Hombre cuya identidad de género si corresponde con el sexo diagnosticado al nacer.<br><b>Travesti:</b> Un término que refleja la experiencia de transitar por el género independientemente de cualquier tipo de modificación corporal, sea esta hormonal, genital, etc. Para algunas personas nombrarse travesti es una reivindicación política, independiente o no de si se reconocen como personas Trans*.',
      };
    },
  },
  methods: {
    labels(variable) {
      const labels = {
        0: {
          NOMBRE: 'Nombres',
          APELLIDO: 'Apellidos',
          DOCUMENTO: 'Tipo de documento',
          GENERO_ID: 'Sexo',
          PAIS_NACIMIENTO_ID: 'País de nacimiento',
          ORIENTACION_ID: 'Orientación sexual',
          IDENTIDAD_GENERO_ID: 'Identidad de género',
          RANGO_EDAD_ID: 'Rango de edad',
          CARACTERISTICAS_DIFERENCIALES: 'Características diferenciales',
          COMUNA_ID: 'Comuna donde reside la persona en riesgo',
          BARRIO_ID: 'Barrio donde reside la persona en riesgo',
          DIRECCION: 'Dirección donde se presenta la situación de alerta',
          PUNTO_REFERENCIA: 'Punto de referencia para ubicar la dirección',
          TELEFONO: 'Teléfono',
          FECHA_NACIMIENTO: 'Fecha de nacimiento',
          GRADO_ESCOLAR_ID: 'Grado escolar',
          NIVEL_ESCOLAR_ID: 'Nivel de escolaridad',
          ESPERA_BEBE: '¿Está esperando bebé?',
          NUMERO_HIJOS_ID: 'Indique el número de hijos, si tiene',
        },
        1: {
          NOMBRE: 'Nombre de la persona en riesgo',
          APELLIDO: 'Apellido de la persona en riesgo',
          DOCUMENTO: 'Tipo de documento de la persona en riesgo',
          GENERO_ID: 'Sexo de la persona en riesgo',
          PAIS_NACIMIENTO_ID: 'País de nacimiento',
          ORIENTACION_ID: 'Orientación sexual de la persona en riesgo',
          IDENTIDAD_GENERO_ID: 'Identidad de género de la persona en riesgo',
          RANGO_EDAD_ID: 'Rango de edad de la persona en riesgo',
          CARACTERISTICAS_DIFERENCIALES: 'Características diferenciales de la persona en riesgo',
          COMUNA_ID: 'Comuna donde reside la persona en riesgo',
          BARRIO_ID: 'Barrio donde reside la persona en riesgo',
          DIRECCION: 'Dirección de residencia de la persona en riesgo',
          PUNTO_REFERENCIA: 'Punto de referencia para ubicar la dirección',
          TELEFONO: 'Teléfono de la persona en riesgo',
          FECHA_NACIMIENTO: 'Fecha de nacimiento de la persona en riesgo',
          GRADO_ESCOLAR_ID:
            'Si sabe, por favor indique el grado escolar que tiene la persona en riesgo',
          NIVEL_ESCOLAR_ID:
            'Si sabe, por favor indique el nivel de escolaridad que tiene la persona en riesgo',
          ESPERA_BEBE: '¿Sabe si la persona que está en riesgo, está esperando bebé?',
          NUMERO_HIJOS_ID:
            'Si sabe, por favor indique el número de hijos que tiene la persona en riesgo',
        },
      };
      if (this.a.A_NOM_DE !== null && this.a.A_NOM_DE >= 0) {
        return labels[this.a.A_NOM_DE][variable];
      }
      return '';
    },
    addPersona() {
      if (this.validatePersona()) {
        if (this.as.editar) {
          this.as = JSON.parse(JSON.stringify(this.ad));
          this.showForm = false;
          return true;
        }

        this.a.PERSONAS_EN_RIESGO.push(JSON.parse(JSON.stringify(this.as)));
        this.as = JSON.parse(JSON.stringify(this.ad));
        this.characteristicsText = 'Seleccionar...';
        this.showForm = false;
        return true;
      }
      this.$bvToast.toast('Error, verifique los campos', {
        variant: 'danger',
        title: 'Error',
      });
      return false;
    },
    editPersona(item) {
      this.as = item;
      this.as.editar = true;
      this.showForm = true;
    },
    validatePersona() {
      return (
        this.vNombre()
        && this.vApellido()
        && this.vDocumento()
        && this.vGeneroId()
        && this.vOrientacionId()
        && this.vRangoEdadId()
        && this.vNivelEscolarId()
        && this.vGradoEscolarId()
        && this.vTelefono()
        && this.vNumeroHijosId()
        && this.validateBirthCountry()
        && this.validateBirthDate()
        && this.validateDifferentialCharacteristics()
        && this.validateGenderIdentity()
        && this.as.POLITICA
      );
    },
    validatePage() {
      if (this.a.PERSONAS_EN_RIESGO.length) {
        return true;
      }
      return false;
    },
    validateBirthCountry() {
      if (this.a.A_NOM_DE === 0 && this.as.PAIS_NACIMIENTO_ID === null) {
        if (this.fb.PAIS_NACIMIENTO_ID === null) {
          return null;
        }
        this.fb.PAIS_NACIMIENTO_ID = 'No olvides indicar tu país de nacimiento.';
        return false;
      }
      this.fb.PAIS_NACIMIENTO_ID = '';
      return true;
    },
    vNombre() {
      if (this.a.A_NOM_DE === 0 && this.as.NOMBRE === null) {
        return null;
      }
      if (this.a.A_NOM_DE === 0 && this.as.NOMBRE === '') {
        this.fb.NOMBRE = 'No olvides indicar el nombre de la persona en riesgo.';
        return false;
      }
      if (this.as.NOMBRE && !expresiones.alphanumeric.test(this.as.NOMBRE)) {
        this.fb.NOMBRE = 'Este campo solo permite caracteres alfanuméricos.';
        return false;
      }
      if (this.as.NOMBRE && this.as.NOMBRE.length > 200) {
        this.fb.NOMBRE = 'Por favor indique un nombre que no supere máximo 200 caracteres.';
        return false;
      }
      return true;
    },
    vApellido() {
      if (this.a.A_NOM_DE === 0 && this.as.APELLIDO === null) {
        return null;
      }
      if (this.a.A_NOM_DE === 0 && this.as.APELLIDO === '') {
        this.fb.APELLIDO = 'No olvides indicar el apellido de la persona en riesgo.';
        return false;
      }
      if (this.as.APELLIDO && !expresiones.alphanumeric.test(this.as.APELLIDO)) {
        this.fb.APELLIDO = 'Este campo solo permite caracteres alfanuméricos.';
        return false;
      }
      if (this.as.APELLIDO && this.as.APELLIDO.length > 200) {
        this.fb.APELLIDO = 'Por favor indique un apellido que no supere máximo 200 caracteres.';
        return false;
      }
      return true;
    },
    vDocumento() {
      if (this.a.A_NOM_DE === 0 && this.as.DOCUMENTO === null) {
        return null;
      }
      if (this.a.A_NOM_DE === 0 && this.as.DOCUMENTO === '') {
        this.fb.DOCUMENTO = 'No olvides indicar el número de documento de la persona en riesgo.';
        return false;
      }
      if (this.as.DOCUMENTO && this.as.DOCUMENTO.length > 20) {
        this.fb.DOCUMENTO = 'Por favor indique un número que no supere máximo 20 caracteres.';
        return false;
      }
      if (this.as.DOCUMENTO && !expresiones.numeric.test(this.as.DOCUMENTO)) {
        this.fb.DOCUMENTO = 'Este campo solo permite caracteres numéricos.';
        return false;
      }
      return true;
    },
    vTelefono() {
      if (this.a.A_NOM_DE === 0 && this.as.TELEFONO === null) {
        return null;
      }
      if (this.a.A_NOM_DE === 0 && !this.as.TELEFONO) {
        return false;
      }
      if (this.as.TELEFONO && !expresiones.phone.test(this.as.TELEFONO)) {
        this.fb.TELEFONO = 'Solo se permiten entre 7 y 10 caracteres numéricos.';
        return false;
      }
      return true;
    },
    vGeneroId() {
      if (this.a.A_NOM_DE === 0 && this.as.GENERO_ID === null) {
        return null;
      }
      if (this.a.A_NOM_DE === 0 && !this.as.GENERO_ID) {
        return false;
      }
      return true;
    },
    vOrientacionId() {
      if (this.a.A_NOM_DE === 0 && this.as.ORIENTACION_ID === null) {
        return null;
      }
      if (this.a.A_NOM_DE === 0 && !this.as.ORIENTACION_ID) {
        return false;
      }
      return true;
    },
    validateGenderIdentity() {
      if (this.a.A_NOM_DE === 0 && this.as.IDENTIDAD_GENERO_ID === null) {
        return null;
      }
      if (this.a.A_NOM_DE === 0 && !this.as.IDENTIDAD_GENERO_ID) {
        return false;
      }
      return true;
    },
    vRangoEdadId() {
      if (this.as.RANGO_EDAD_ID === null) {
        return null;
      }

      if (this.as.RANGO_EDAD_ID === '') {
        this.fb.RANGO_EDAD_ID = 'No olvides indicar la edad de la persona en riesgo.';
        return false;
      }

      if (!this.as.FECHA_NACIMIENTO) {
        return true;
      }

      const today = new Date();
      const birthDate = new Date(this.as.FECHA_NACIMIENTO);
      birthDate.setDate(birthDate.getDate() + 1);

      // If it's in the future, avoid validations here to show them in the birth date field.
      if (birthDate.getTime() >= today.getTime()) {
        return null;
      }

      const currentAgeRange = this.getAgeRangeFromBirthDate(birthDate);
      if (currentAgeRange && this.as.RANGO_EDAD_ID !== currentAgeRange.value) {
        this.fb.RANGO_EDAD_ID = 'El rango de edad no corresponde a la fecha de nacimiento seleccionada.';
        return false;
      }
      return true;
    },
    vNivelEscolarId() {
      if (this.a.A_NOM_DE === 0 && this.as.NIVEL_ESCOLAR_ID === null) {
        return null;
      }
      if (this.a.A_NOM_DE === 0 && !this.as.NIVEL_ESCOLAR_ID) {
        return false;
      }
      return true;
    },
    vGradoEscolarId() {
      if (this.filteredSchoolGrades.length <= 1) {
        return true;
      }
      if (this.a.A_NOM_DE === 0 && this.as.GRADO_ESCOLAR_ID === null) {
        return null;
      }
      if (this.a.A_NOM_DE === 0 && !this.as.GRADO_ESCOLAR_ID) {
        return false;
      }
      return true;
    },
    vNumeroHijosId() {
      if (this.a.A_NOM_DE === 0 && this.as.NUMERO_HIJOS_ID === null) {
        return null;
      }
      if (this.a.A_NOM_DE === 0 && !this.as.NUMERO_HIJOS_ID) {
        return false;
      }
      return true;
    },
    validateBirthDate() {
      if (this.a.A_NOM_DE === 0 && this.as.FECHA_NACIMIENTO === null) {
        if (this.fb.FECHA_NACIMIENTO === null) {
          return null;
        }

        this.fb.FECHA_NACIMIENTO = 'La fecha de nacimiento es obligatoria.';
        return false;
      }

      if (!this.as.FECHA_NACIMIENTO) {
        return true;
      }

      const birthDate = new Date(this.as.FECHA_NACIMIENTO);
      birthDate.setDate(birthDate.getDate() + 1);
      if (birthDate.getTime() > Date.now()) {
        this.fb.FECHA_NACIMIENTO = 'La fecha de nacimiento no puede ser en el futuro.';
        return false;
      }
      this.fb.FECHA_NACIMIENTO = '';
      return true;
    },
    validateDifferentialCharacteristics() {
      if (this.a.A_NOM_DE === 0 && this.characteristicsSelected.length === 0) {
        if (this.fb.CARACTERISTICAS_DIFERENCIALES === null) {
          return null;
        }
        this.fb.CARACTERISTICAS_DIFERENCIALES = 'Las características diferenciales son obligatorias.';
        return false;
      }
      this.fb.CARACTERISTICAS_DIFERENCIALES = '';
      return true;
    },
    updateCharacteristicText(newElementText, value) {
      const index = this.characteristicsSelected.indexOf(newElementText);
      if (value === 0 && index === -1) {
        this.characteristicsSelected.push(newElementText);
      }

      if (value === 1 && index > -1) {
        this.characteristicsSelected.splice(index, 1);
      }

      this.characteristicsText = this.characteristicsSelected.join(', ');
      this.characteristicsText = this.characteristicsText || 'Seleccionar...';
    },
    updateBirthDate(birthDateString) {
      this.as.FECHA_NACIMIENTO = birthDateString;

      const birthDate = new Date(birthDateString);
      birthDate.setDate(birthDate.getDate() + 1);
      if (birthDate.getTime() < Date.now()) {
        const currentAgeRanges = this.getAgeRangeFromBirthDate(birthDate);
        this.as.RANGO_EDAD_ID = currentAgeRanges?.value ?? this.as.RANGO_EDAD_ID;
      }
    },
    getAgeRangeFromBirthDate(birthDate) {
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      const dayDiff = today.getDate() - birthDate.getDate();

      // If no birthday yet this year, determine the age with the remaining months and days
      if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
        age -= 1;
      }
      return this.ageRanges.find((ageRange) => age <= ageRange.maxAge && age >= ageRange.minAge);
    },
  },
  created() {
    this.as = JSON.parse(JSON.stringify(this.ad));
  },
  mounted() {
    if (this.editar) {
      this.showForm = false;
    } else {
      this.showForm = !(this.a.PERSONAS_EN_RIESGO.length > 0);
    }
  },
  watch: {
    a: {
      deep: true,
      handler() {
        this.validatePage();
      },
    },
    as: {
      deep: true,
      handler() {
        this.comunaSelected = this.as.COMUNA_ID;
        this.barrioSelected = this.as.BARRIO_ID;
        if (this.as.id) {
          this.as.POLITICA = true;
        }
      },
    },
    comunaSelected() {
      this.as.COMUNA_ID = this.comunaSelected;
      this.as.COMUNA_NAME = this.getTextById(this.comunaSelected, 'comunas', 'text');
      if (!this.as.editar) {
        this.barrioSelected = null;
        this.as.BARRIO_ID = null;
        this.as.BARRIO_NAME = this.getTextById(this.barrioSelected, 'barrios', 'text');
      }
    },
    barrioSelected() {
      this.as.BARRIO_ID = this.barrioSelected;
      this.as.BARRIO_NAME = this.getTextById(this.barrioSelected, 'barrios', 'text');
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-add-person {
  color: #bc86d0;
  cursor: pointer;

  &.float-right {
    margin-left: auto;
    margin-right: 0;
  }

  &[disabled] {
    opacity: 0.5;
    pointer-events: none;
  }
}

.b-table {
  margin-bottom: 0px;
}
</style>

<style lang="scss">
.satmed-btn-dropdown > button {
  white-space: break-spaces;
  height: initial;
}
</style>
